import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getBankAccountListApi = (params, callback) => {
    return async () => {
        try {
            await apiGet(`${ApiConstants.bankAccountUrl}`).then((response) => {
                callback && callback(response, response);
            });
        } catch (error) {
            console.log("get bank account lists api err:", error);
            throw error;
        }
    };
};
export const upsertBankAccountApi = (data, callback) => {
    return async () => {
        try {
            const response = await apiPost(
                `${ApiConstants.bankAccountUrl}`,
                data
            );
            callback && callback(response, response?.data);
        } catch (error) {
            console.log("add bank account api err:", error);
            throw error;
        }
    };
};